import { Router } from '@angular/router';
import { SectorModel } from './../../service/sector.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DropzoneComponent, DropzoneConfigInterface, DROPZONE_CONFIG, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { TrainService } from './../../service/train.service';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Observable, Subscription, interval } from 'rxjs';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ShowLogDialogComponent } from '../../show-log-dialog/show-log-dialog.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html',
  styleUrls: ['./step2.component.css']
})
export class Step2Component implements OnInit, OnDestroy {

  bsModalRef: BsModalRef;
  @ViewChild(DropzoneDirective) directiveRef: DropzoneDirective;
  sectormodel = new SectorModel;
  enableGetLogs: boolean;
  click = true;
  firstClick: boolean;
  result:any = {};
  sub: Subscription;
  Status: string;

  public config: DropzoneConfigInterface = {
    url: '/api/TrainExisting/SaveUploadedFileExisting',
    clickable: true,
    headers: {
      'Sector': this.dbconnectorservice.SectorName,
      'Model': this.dbconnectorservice.ModelName
    },
    uploadMultiple: true,
    parallelUploads: 3,
    autoReset: null,
    errorReset: 15000,
    cancelReset: 15000,
    createImageThumbnails: true,
    dictDefaultMessage: 'Drag and Drop or Click to browse for files',
    acceptedFiles: '.xlsm,.xlsx',


  };

  constructor(private dbconnectorservice: DBConnectorService,
    private trainservice: TrainService,
    private http: HttpClient,
    private router: Router,
    private _dialogService: BsModalService
    ) {

    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
    this.sectormodel.User = this.dbconnectorservice.username;
    this.configset();
  }
  configset() {

    const url1 = '/api/TrainExisting/SaveUploadedFileExisting';
    // const resource = this.adalService.GetResourceForEndpoint(url1);
    // const token = this.adalService.getCachedToken(resource);
    // const tokenbearer = 'Bearer ' + token;

    this.config = {
      url: url1,
      headers: {
        'Authorization': this.dbconnectorservice.getToken(url1),
        'Sector': this.dbconnectorservice.SectorName,
        'Model': this.dbconnectorservice.ModelName
      },
      uploadMultiple: true,
      parallelUploads: 3,
      autoReset: null,
      errorReset: 15000,
      cancelReset: 15000,
      createImageThumbnails: true,
      dictDefaultMessage: 'Drag and Drop or Click to browse for files',
      acceptedFiles: '.xlsm,.xlsx',
      clickable: true,
      timeout: 240000

    };
  }
  onUploadError(args: any) {
    // console.log('onUploadError:', args);
  }
  onUploadSuccess(args: any) {
    // console.log('onUploadSuccess:', args);
    this.result = args[1];
  }

  // FileUpload
  fileChange(event: any) {
    alert('Uploading Files');
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      console.log(fileList);
      for (const i in fileList) {
        const file: File = fileList[i];
        const formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        //console.log(formData);

        let options = {
          headers: new HttpHeaders({
            'Accept': 'application/json',
            'Sector': this.dbconnectorservice.SectorName,
            'Model': this.dbconnectorservice.ModelName
          })
        }
        let apiUrl = '/api/TrainExisting/SaveUploadedFileExisting';
        this.http.post<any>(apiUrl, formData, options)
          //.catch(error => Observable.throw(error))
          .subscribe(
            data => {
              console.log('Files uploaded');
            }
            //error => console.log('error');
          );
      }
      alert('Files Uploaded');
    }
  }

  preprocessExisting() {

    console.log('Preprocess - start');
    this.click = false;
    this.enableGetLogs = true;
    this.firstClick = true;
    this.trainservice.PreprocessExisting(this.sectormodel)
      .subscribe(
        (data) => {
          this.result = data;
          console.log(this.result);
          console.log('Preprocess - after api');
          // if (data['Success']) {
          //   this.router.navigate(['Train/Step3']);

          // }
        });
  }

  redirect() {
    this.router.navigate(['Home/Update']);
  }

  CancelTrain() {

    this.trainservice.cancelTrain(this.sectormodel)
      .subscribe(
        (data) => { });
  }

  StatusCheck() {

    this.trainservice.statusCheck(this.sectormodel)
      .subscribe(
        (data) => {
          this.Status = data;
          if (this.Status === 'PROCESSING EXIST') {
            this.click = false;
            this.enableGetLogs = true;
          } else if (this.Status === 'PROCESSED' && this.click === false) {
            this.router.navigate(['Train/Step3']);
          } else {
            this.click = true;
          }
          console.log(this.Status);
        });

  }

  ngOnInit() {
    this.StatusCheck();

    this.sub = interval(5000).subscribe(x => {
      if (this.click === false && this.firstClick === true) {
        setTimeout(()=>{
          this.StatusCheck();
          this.firstClick = false;
        }, 20000);
        
      }
      else if (this.click === false) {
        this.StatusCheck();
      }
    });
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  OpenLogsDialog() {
    console.log("clicked!")
    const initialState = {
      source: "preprocess_existing",
      username: this.sectormodel.User
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    //this._dialogService.addDialog(ShowLogDialogComponent, { source: "preprocess_existing", username: this.sectormodel.User }).subscribe(data => console.log(data))
  }
}
